import { createSlice } from "@reduxjs/toolkit";

export const homePageSlice = createSlice({
  name: "ConfigData",
  initialState: {
    ConfigData: {},
    headerTitle: "Select Product",
  },
  reducers: {
    saveConfigData: (state, action) => {
      state.ConfigData = action.payload;
    },
    saveHeaderTitle: (state, action) => {
      state.headerTitle = action.payload;
    },
  },
});

export const { saveConfigData, saveHeaderTitle } = homePageSlice.actions;

export default homePageSlice.reducer;
